<template>
    <router-link
        :to="{
            name: 'view-user',
            params: { user_id: resource.id }
        }"
        class="user"
    >
        <img
            :src="resource.avatar ? `/images/avatar/${resource.id}`: '//placehold.it/32x32'"
            class="avatar avatar--small"
            :title="resource.name"
            :alt="`${resource.name}'s avatar`"
            :key="resource.id"
            width="32"
            height="32"
        />
        <span v-if="showName && resource.name" v-text="resource.name" />
    </router-link>
</template>
<script>
    export default {
        name: 'Avatar',
        props: {
            resource: {
                type: Object,
                required: true,
            },
            showName: {
                type: Boolean,
                default: true,
            }
        }
    }
</script>
<style lang="scss" scoped>
    .avatar {
        margin-right: 0;
    }
</style>
